export const selectBannersLoadingState = state => state.banners.loading

export const selectBannersError = state => state.banners.error

export const selectBannersData = state => state.banners.data
